import { IVideoListPageInfo } from '../../common/interfaces/IVideoListPageInfo'

export const directorOfPhotographyPageInfo: IVideoListPageInfo = {
  pageTitle: 'Director of Photography',
  videoTitles: [
    'How Corporations Raided Medicare',
    "What Energy Compnaies Don't Want You To Know",
    'From Mass to the Mountain',
    'Peak Performance: Flying the Fire Boss',
    'Real Pilot Story: Hidden Hazard',
    'Real Pilot Story: The Heat of the Moment',
    'Real Pilot Story: Lost Elevator',
    'Real Pilot Story: Pressure Over the Atlantic',
    'Real Pilot Story: No Go-Around',
    'Real Pilot Story: Powerless Over Paris',
    'What are the Costliest Insurance Claims?',
    'Afro Punk Ballet',
    'Meet The Pill Bug',
    "Fox Haven Farm's Herb CSA promo",
    'Horseshoes $ Hand Grenades Live at Pabst Theater',
    'Lizzy Young: Kill All The Men',
    'HOT 97 Family Dinner Celebrating Hispanic Heritage Month',
    'DJ Enuff Makes "Home Grown" Dish',
    'Beyond Proficient: Flying to Catalina Island',
    'Beyond Proficient: STOL Goal',
    'Beyond Proficient: Extra 300 Series | Part One, Meet the Extra',
    'Beyond Proficient: Extra 300 Series | Part Two, The Flight',
    'Beyond Proficient: Extra 300 Series | Part Three, Intro to Aerobatics',
    'Avoiding Gear-Up Landings',
    'Avoiding Prop Strikes',
    'Avoiding Hard Landings',
    'Avoiding LOC-G',
    'Cambrooke BetterMilk',
    'P-51 Engine Out',
    'Flyoff: Beech Staggerwing vs. Howard DGA-15',
  ],
}
